import { supabase } from "../lib/supabase";
import { checkApplicant } from "./applicants";

export const requestVerificationCode = async (email) => {
  try {
    // 1. Check if email exists in applicants
    const { data: applicant } = await checkApplicant(email.trim());
    if (!applicant) {
      return { success: false, message: "البريد الإلكتروني غير مسجل في النظام" };
    }

    // 1.5 Check if user is in a team and team submitted a project
    const { data: memberships } = await supabase
      .from('team_members')
      .select('team_id')
      .eq('applicant_id', applicant.id);

    if (!memberships || memberships.length === 0) {
      return { success: false, message: "عذراً، يجب أن تكون عضواً في فريق للحصول على الشهادة" };
    }

    const teamIds = memberships.map(m => m.team_id);
    
    // Check if any of the teams submitted a project
    const { data: projects } = await supabase
      .from('projects')
      .select('id')
      .in('team_id', teamIds)
      .eq('submitted', true)
      .limit(1);

    if (!projects || projects.length === 0) {
      return { success: false, message: "عذراً، يجب أن يكون فريقك قد سلم المشروع للحصول على الشهادة" };
    }

    // 2. Check if already got certificate
    const { data: certificate } = await supabase
      .from("certificates")
      .select("id")
      .eq("email", email)
      .maybeSingle();

    if (certificate) {
      return { success: false, message: "تم إصدار الشهادة لهذا البريد الإلكتروني مسبقًا" };
    }

    // 3. Generate code
    const code = Math.floor(100000 + Math.random() * 900000).toString();
    
    // 4. Save code
    const { error: codeError } = await supabase
      .from("verification_codes")
      .upsert({ 
        email, 
        code, 
        expires_at: new Date(Date.now() + 15 * 60 * 1000).toISOString() // 15 mins
      });

    if (codeError) throw codeError;

    // 5. Send email
    const apiUrl = process.env.REACT_APP_API_URL || "https://api.qimma.dev/api/email/send";
    
    const emailResponse = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: email,
        subject: "رمز التحقق - شهادة المشاركة في هاكاثون قمة",
        html: `
          <div dir="rtl" style="font-family: Arial, sans-serif; text-align: right;">
            <h2>رمز التحقق الخاص بك</h2>
            <p>مرحباً ${applicant.full_name}،</p>
            <p>استخدم الرمز التالي لإكمال عملية الحصول على شهادة المشاركة:</p>
            <h1 style="color: #05339c; letter-spacing: 5px;">${code}</h1>
            <p>هذا الرمز صالح لمدة 15 دقيقة.</p>
          </div>
        `
      })
    });

    if (!emailResponse.ok) {
       console.error("Email API failed");
       return { success: false, message: "فشل إرسال البريد الإلكتروني" };
    }
    
    return { success: true, message: "تم إرسال رمز التحقق إلى بريدك الإلكتروني" };

  } catch (error) {
    console.error("Error in requestVerificationCode:", error);
    return { success: false, message: "حدث خطأ غير متوقع" };
  }
};

export const submitCertificateRequest = async (email, code, fullName) => {
  try {
    // Derive certificate API URL from the email API URL or use default
    const emailApiUrl = process.env.REACT_APP_API_URL || "https://api.qimma.dev/api/email/send";
    // Replace '/email/send' with '/certificate' to get '.../api/certificate'
    const certificateApiUrl = emailApiUrl.replace(/\/send$/, "/certificate");
    
    const response = await fetch(certificateApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        name: fullName,
        code
      })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
        // Handle Supabase error PGRST116 (No rows found) which typically means invalid/expired code
        if (data.code === "PGRST116") {
             return { success: false, message: "رمز التحقق غير صحيح أو منتهي الصلاحية" };
        }
        return { success: false, message: data.message || "حدث خطأ أثناء تقديم الطلب" };
    }
    
    // Clean up used code if API success
    await supabase.from("verification_codes").delete().eq("email", email);

    return { success: true, message: "تم تسجيل طلبك بنجاح! سيتم إرسال الشهادة إليك قريبًا." };

  } catch (error) {
    console.error("Error in submitCertificateRequest:", error);
    return { success: false, message: "حدث خطأ أثناء الاتصال بالخادم" };
  }
};
